module.exports = __webpack_public_path__ + "img/aboutuspic2.bc749dfc.jpg";